import axios from 'axios';

const client = (token) =>
  axios.create({
    baseURL: 'https://us-central1-oshi-3bcd4.cloudfunctions.net/webApi',
    timeout: 30000,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  });

export default client;
